import { Add, Delete, Edit, Visibility } from "@material-ui/icons";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  makeStyles,
} from "@material-ui/core";
import React, { createRef, useEffect, useState } from "react";
import { deleteSailor, fetchSailors } from "../../../../services/sailorService";

import CreateDialog from "../../Sailors/CreateDialog";
import CustomDeleteDialog from "../../../components/CustomDeleteDialog";
import CustomTable from "../../../components/Table";
import UpdateDialog from "../../Sailors/UpdateDialog";
import dayjs from "dayjs";
import { fetchDiplomaKinds } from "../../../../services/diplomaKindService";
import { fetchPortAuthorities } from "../../../../services/portAuthoritiesService";
import queryFunction from "../../../../utils/queryFunction";
import useLocale from "../../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
  card: {
    marginTop: "1rem",
    marginBottom: "1.5rem",
  },
  applicationCard: {
    maxWidth: "80vw",
  },
});

function Sailor({ setErrorSailor, setSelectedSailor }) {
  const { t } = useLocale();
  const classes = useStyles();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [isError, setIsError] = useState(false);
  const [tableData, setTableData] = useState([]);

  const tableRef = createRef();

  const refreshTable = () => {
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
  };

  return (
    <>
      <CustomTable
        ref={tableRef}
        columns={[
          {
            title: t("Sailor Identification Number"),
            field: "s_am",
          },
          {
            title: t("Ameth"),
            field: "s_ameth",
          },
          {
            title: t("First Name"),
            field: "s_first_name",
          },
          {
            title: t("Last Name"),
            field: "s_last_name",
          },
          {
            title: t("Father Name"),
            field: "s_f_name",
          },
          {
            title: t("Mother name"),
            field: "s_m_name",
          },
          {
            title: t("Birth Date"),
            field: "s_birth_date",
            render: (rowData) => {
              return (
                <span>{dayjs(rowData?.s_birth_date).format("DD/MM/YYYY")}</span>
              );
            },
          },
          {
            title: t("ANI"),
            field: "s_ani",
          },
          {
            title: t("Diploma Kind"),
            field: "d_name",
          },
        ]}
        data={(query) => queryFunction(query, fetchSailors, setIsError)}
        options={{
          showSelectAllCheckbox: false,
          selection: true,
        }}
        onSelectionChange={(rows) => {
          if (rows.length > 1) {
            setSelectedSailor("");
            setErrorSailor(t("Please select one Sailor"));
          } else {
            if (rows.length !== 0) {
              setErrorSailor("");
              setSelectedSailor(rows[0]);
            } else {
              setSelectedSailor("");
              setErrorSailor("");
            }
          }
        }}
        actions={[
          {
            icon: () => <Add />,
            tooltip: t("Add"),
            isFreeAction: true,
            onClick: () => {
              setIsCreateDialogOpen(true);
            },
          },
          {
            icon: () => <Visibility style={{ color: "#000" }} />,
            tooltip: t("View"),
            onClick: (event, rowData) => {
              setIsViewDialogOpen(true);
              setSelectedItem(rowData[0]);
            },
          },
          {
            icon: () => <Edit style={{ color: "#1E90FF" }} />,
            tooltip: t("Edit"),
            onClick: (event, rowData) => {
              setIsUpdateDialogOpen(true);
              setSelectedItem(rowData[0]);
            },
          },
          {
            icon: () => <Delete style={{ color: "#B22222" }} />,
            tooltip: t("Delete"),
            onClick: (event, rowData) => {
              setIsDeleteDialogOpen(true);
              setSelectedItem(rowData[0]);
            },
          },
        ]}
      />
      <CreateDialog
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        refetch={refreshTable}
      />
      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        refetch={refreshTable}
        selectedItem={selectedItem}
      />
      {/* <ViewDialog
        open={isViewDialogOpen}
        close={() => setIsViewDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
      /> */}
      <CustomDeleteDialog
        title={t("Delete Sailor")}
        message={t(
          "Are you sure you want to delete the selected Sailor with Sailor Identification Number"
        )}
        fieldName="am"
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        refetch={refreshTable}
        selectedItem={selectedItem}
        deleteService={deleteSailor}
      />
    </>
  );
}

export default Sailor;
